<template>
  <div @click="$emit('toggleRound', votingRound.id)"
    class="mb-3 position-relative sidebar-card highlight-hover p-3 rounded h5"
    :class="selected ? 'bg-theme' : 'bg-blur-darker text-white'">
    <AVIcon icon="vote-yea" /> {{ label }}
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { computed } from "vue";
import { label as xLabel } from "@/entrypoints/shared/voting_rounds_helper";
import type { PropType, ConferenceVotingRound, SupportedLocale } from "@/types";

const { locale } = useI18n();

const props = defineProps({
  votingRound: {
    type: Object as PropType<ConferenceVotingRound>,
    required: true,
  },
  selected: {
    type: Boolean,
    default: false,
  },
});

const label = computed(() => xLabel(props.votingRound, locale.value as SupportedLocale));
</script>

<style scoped>
.highlight-hover:hover {
  cursor: pointer;
  box-shadow: 0 0 0 2px white;
}
</style>
